import React from 'react';
import { Options } from 'react-select';

import { Icon } from '../icon/Icon';
import { Delete } from '../icons';
import styles from './Button.module.scss';
import { OverflowTooltip } from '../tooltip';
import { Dropdown, DropdownOption } from '../dropdown/Dropdown';

interface DocumentLinkWithDropdownButtonProps {
    open: () => void;
    remove: () => void;
    buttonLabel: string;
    header: string;
    showRemove: boolean;
    showDropdown: boolean;
    dropdownOption: DropdownOption | null;
    dropdownOptions: DropdownOption[];
    selectDropdown: (parentOption: DropdownOption | Options<DropdownOption> | null) => void;
    testId?: string;
    disabled?: boolean;
}

export const DocumentLinkWithDropdownButton: React.FC<DocumentLinkWithDropdownButtonProps> = ({
    open,
    remove,
    buttonLabel,
    showRemove,
    showDropdown,
    dropdownOption,
    dropdownOptions,
    selectDropdown,
    testId = 'document-agreement-link-button',
    header,
    disabled = false
}) => (
    <div data-testid={`${testId}-wrapper`} className={styles.documentLinkWrapper}>
        <div className={styles.documentLinkHeader} data-testid={`${testId}-header`}>{header}</div>
        {showDropdown &&
            <div className={styles.documentLinkDropdown}>
                <Dropdown
                    value={dropdownOption}
                    options={dropdownOptions}
                    onChange={selectDropdown}
                    testId='upload-document-link-agreement-type'
                    placeholder='Select Agreement Type'
                    menuPortalTarget={document.body}
                />
            </div>
        }
        <div className={styles.buttonWrapper}>
            <button data-testid={`${testId}-button`} onClick={open} className={styles.linkButton} disabled={disabled}>
                <OverflowTooltip overlayText={buttonLabel} />
            </button>
            {showRemove &&
                <button className={styles.removeLink} onClick={remove} disabled={disabled}>
                    <Icon icon={Delete} fontSize={25} />
                </button>
            }
        </div>
    </div>
);
